export interface UserCreateRequest {
  name: string;
  username: string;
  role: string;
  emplid: string;
  base_price: string;
  password: string;
  email: string;
}

export interface User {
  name: string;
  username: string;
  rol: Role;
  emplid: string;
  base_price: string;
  cellIdentification: string | null;
  email: string;
}

export interface UserEditRequest {
  name: string;
  username: string;
  role: string;
  emplid: string;
  base_price: string;
  password: string;
  email: string;
}

export interface Role {
  idRole: string;
  roleName: string;
}

export interface RoleRequest {
  idRole: string;
  roleName: string;
}

export function UserActions() {
  function createUserRequest(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string
  ): UserCreateRequest {
    return {
      name: name,
      username: username,
      role: role,
      emplid: emplid,
      base_price: base_price,
      password: password,
      email: email,
    };
  }

  function createUser(
    name: string,
    username: string,
    rol: Role,
    emplid: string,
    base_price: string,
    cellIdentification: string | null,
    email: string
  ): User {
    return {
      name: name,
      username: username,
      rol: rol,
      emplid: emplid,
      base_price: base_price,
      cellIdentification: cellIdentification,
      email: email,
    };
  }

  function createRole(id: string, roleName: string): Role {
    return {
      idRole: id,
      roleName: roleName,
    };
  }

  function editUserRequest(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string
  ): UserEditRequest {
    return {
      name: name,
      username: username,
      role: role,
      emplid: emplid,
      base_price: base_price,
      password: password,
      email: email,
    };
  }

  function deserialize(object: string): User[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((user: User) => {
      return createUser(
        user.name,
        user.username,
        user.rol,
        user.emplid,
        user.base_price,
        user.cellIdentification,
        user.email
      );
    });
  }

  return {
    createUserRequest,
    createUser,
    editUserRequest,
    deserialize,
    createRole,
  };
}
